import React from 'react';
import { IWizardContent } from './interfaces';
import { Box, Typography } from '@mui/material';

export const WizardContent: React.FC<IWizardContent> = ({
  text,
  children,
}): JSX.Element => {
  return (
    <Box>
      <Typography
        sx={{
          mb: '15px',
        }}
      >
        {text}
      </Typography>

      {children}
    </Box>
  );
};
